import React, { useEffect, useState } from 'react'
import { FaCalendar } from 'react-icons/fa';
import { downloadReport } from '../../utils/reportUtils';

const GenerateReport = ({ isOpen, onClose, reportTitle, minLimit, maxLimit, handleGenerate }) => {
    const [month, setMonth] = useState('');
    const [error, setError] = useState('');

    const formatMonth = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        return `${year}-${month}`;
    };

    const now = new Date();

    // 24 months back
    const minDate = new Date(now.getFullYear(), now.getMonth() - minLimit, 1);

    // 1 month ahead
    const maxDate = new Date(now.getFullYear(), now.getMonth() + maxLimit, 1);

    const minMonth = formatMonth(minDate);
    const maxMonth = formatMonth(maxDate);

    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }

        return () => {
            document.body.style.overflow = '';
        };
    }, [isOpen]);

    const handleChange = (e) => {
        const val = e.target.value;
        if (val >= minMonth && val <= maxMonth) {
            setMonth(val);
        }
    };


    const handleDownload = () => {
        setError('');

        if (!month) {
            setError('Month is required');
            return;
        }

        handleGenerate("demand", month);
        setMonth('');
        onClose();
    };

    if (!isOpen) return null;

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="download-modal-dialog" onClick={(e) => e.stopPropagation()}>
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">{reportTitle}</h5>
                        <button onClick={onClose} className="btn-close">
                            {/* <IoMdClose size={20} /> */}
                        </button>
                    </div>

                    <div className="modal-body">
                        <div className="mb-3">
                            <label className="form-label">
                                <FaCalendar size={16} className="me-2" />
                                Select Month
                            </label>
                            <input
                                type="month"
                                value={month}
                                min={minMonth}
                                max={maxMonth}
                                onChange={handleChange}
                                className="form-control"
                            />
                        </div>

                        {error && (
                            <div className="alert alert-danger">
                                {error}
                            </div>
                        )}
                    </div>

                    <div className="modal-footer">
                        <button 
                            onClick={handleDownload} 
                            className="search-btn"
                        >
                            {/* <FaDownload size={18} className="me-2" /> */}
                            Download
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default GenerateReport;